import React from "react"
import { Outlet, ScrollRestoration } from "react-router-dom"
import "./utils/normalize.css"
import "./App.scss"
import { ErrorBoundary, Footer, Header } from "./components"
import { QueryClient, QueryClientProvider } from "react-query"
import { TextStorageProvider } from "./hooks"

const App: React.FC = () => {
  const queryClient = new QueryClient()

  return (
    <div className={"page-outer-shell"}>
      <ScrollRestoration />
      <ErrorBoundary>
        <TextStorageProvider>
          <Header />
          <QueryClientProvider client={queryClient}>
            <Outlet />
          </QueryClientProvider>
          <Footer />
        </TextStorageProvider>
      </ErrorBoundary>
    </div>
  )
}

export default App
